import { h } from 'preact';
import { URLS } from '../Urls';

export const ShippingTaxHint = () => (
  <p className="small text-muted mb-0">
    Inklusive Steuern.{' '}
    <a href={URLS.shippingInfo} title="Hinweise zum Versand">
      Versand
    </a>{' '}
    wird beim Checkout berechnet.
  </p>
);
